export const REGISTER_URL =
  "https://accounts.google.com/signup/v2/webcreateaccount?continue=https%3A%2F%2Faccounts.google.com%2FManageAccount%3Fnc%3D1&dsh=S788943628%3A1637848037323619&biz=false&flowName=GlifWebSignIn&flowEntry=SignUp";
